const planNames = {
  monthly: {
    1: 'MONTHLY',
    2: 'MONTHLY_2PCS',
    3: 'MONTHLY_3PCS',
  },
}


export default planNames
